import * as React from "react";
import { UserService } from "@fnv-core/authentication";
import { MijnFNVMenu } from "../widgets/MijnFNVMenu";
import { PageHelpers } from "./helpers/PageHelpers";
import { PageRenderHelpers } from "./helpers/PageRenderHelpers";
import { PageProps } from "./interfaces/PageInterfaces";
import { MenuHelpers } from "./helpers/MenuHelpers";
import ReactHtmlParser from "react-html-parser";
import { FormService } from "../../services/FormService";
import { MijnFNVPageContext } from "./helpers/MijnFNVPageContext";
import StickyBox from "react-sticky-box";
import { SidebarContent } from "../../presentational/SidebarContent";
import { AnimationService, ANIMATION_DASHBOARD_LOADING_CONTEXT } from '../../services/AnimationService';
import { getAllUrlParams } from '../../../jslibs/urlparams';
import { getResourceString } from '../../kentico/resource-strings';
import { BackLink } from "./components/back-link";
import { createRef } from "react";

const HeaderWrapper = (props : any) => {
  if (!!props.modern) {
    return <div className="row">
      <div className={props.pageWidthCssClass}><div className="editpage-container__layout-modern-titleblock py-4">{props.children}</div></div>
      <div className="col-md-4"></div>
    </div>;
  }
  return <>{props.children}</>;
};


export interface EditPageState {
  IsMember : boolean;
  FullName : string;
}

export class EditDataPage extends React.Component<PageProps , EditPageState> {
  state = {
    IsMember : false,
    FullName : ""
  };

  sidebarRef = createRef<HTMLDivElement>();


  componentDidMount() {
    FormService.setMemberDetailsCallback(this.setMemberDetails);

    AnimationService.enableFormAnimations();
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
  }

  componentWillUnmount() {
    FormService.setMemberDetailsCallback(undefined);
  }

  componentDidUpdate() {
    this.handleAnimations();
  }

  handleAnimations() {
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    AnimationService.triggerAnimations();
  }

  setMemberDetails = () => {
    const memberDetails = FormService.getLidZoekenSubFunctionsForMember();
    if (memberDetails && memberDetails.memberName) {
      this.setState({
        FullName : memberDetails.memberName,
        IsMember : memberDetails.isMember
      });
    } else {
      this.setState({FullName: "", IsMember: false});
    }
  } 

  render() {
    const props = this.props;

    const MijnFnvEditPagina = props.kenticoPage.MijnFnvEditPagina;
      const { 
          BackLinkIsExternal , BackLinkExternalUrl 
      } = MijnFnvEditPagina;

    const standaloneFormInSite =
      props.standaloneFormInSite !== undefined && props.standaloneFormInSite;

    if (props.withBackLink === undefined || props.withBackLink) {
      if (props.kenticoPage.MijnFnvEditPagina.MenuType === "eenvoudig") {
        MenuHelpers.hideMenu();
      } else {
        MenuHelpers.showMenu();
      }
    }

    if (!standaloneFormInSite) {
      if (props.kenticoPageType === "FNV.MijnFnvLoginAlsPagina") {
        MenuHelpers.hideBreadCrumbs();
      } else if (props.kenticoPage.MijnFnvEditPagina.HideSteps) {
        MenuHelpers.showBreadCrumbsEditPage();
      } else {
        MenuHelpers.hideBreadCrumbs();
      }
      PageHelpers.setBreadcrumbsPageTitle(
        props.kenticoPage.MijnFnvEditPagina.Titel
      );
    } else {
      MenuHelpers.showBreadCrumbs();
    }

    let pageWidthCssClass = PageRenderHelpers.getCssClassForEditPageWidth(
      props.kenticoPage.MijnFnvEditPagina.PageWidth,
      props.kenticoPage.MijnFnvEditPagina.ShowSideBar
    );

    let backToPageLinkText =
      props.kenticoPage.MijnFnvEditPagina.BackToPageLinkText ||
      getResourceString("Form.MijnFNV.GoBackText") || "Terug naar Mijn FNV";

    let backToPageLinkUrl = PageHelpers.getMijnFNVRootPathForRole(
      BackLinkIsExternal ? BackLinkExternalUrl : props.kenticoPage.MijnFnvEditPagina.BackToPageLinkUrl || "/"
    );

    let additionalId = "";
    let urlParams = getAllUrlParams(this.context.search);
    if (urlParams.gobackUrl) {
      backToPageLinkUrl = urlParams.gobackUrl;
      backToPageLinkText = getResourceString("Form.MijnFNV.BackText") || "Terug";
      if (urlParams.backTitleForCurrentPageBackLink) {
        backToPageLinkText = getResourceString("Form.MijnFNV.BackToText") + " " + urlParams.backTitleForCurrentPageBackLink;
      }
    } else
    if (!!props.kenticoPage.MijnFnvEditPagina.IncludeAdditionalIdInBackLink) {
      if (urlParams["additionalId"]) {
        additionalId = urlParams["additionalId"];
        backToPageLinkUrl = backToPageLinkUrl + "?additionalId=" + additionalId;
      }
    }
    FormService.setBackUrl(backToPageLinkUrl);

    let sidebar = "";
    if (props.sideBarHtml) {
      sidebar = ReactHtmlParser(props.sideBarHtml);
    }

    let showLineBelowTitleBlock =
      (props.subTitle && props.subTitle !== "") ||
      (props.introText && props.introText !== "");

    let cssColumnsContentContainer = "col-12 col-md-10";
    if (props.kenticoPageType === "FNV.MijnFnvLoginAlsPagina") {
      cssColumnsContentContainer = "col-12";
      pageWidthCssClass = "col-md-12";
    } else if (props.kenticoPage.MijnFnvEditPagina.ShowSideBar) {
      cssColumnsContentContainer = "col-12 col-md-8";
    }

    let pageRowCssClass =
      "row mijn-fnv__edit-page" + (standaloneFormInSite ? " no-gutters" : "");
    let mainBlockRowCssClass =
      "row mainBlock-row" + (standaloneFormInSite ? " no-gutters" : "");

    if (standaloneFormInSite) {
      cssColumnsContentContainer = "col-12";
    }

    let nameMemberInLidZoekenSubfunction = "";
    let memberState = <></>;

    
    if (
      this.context &&
      this.context.pathParam &&
      this.context.pathParam !== UserService.getUserId()
    ) {
      const memberDetails = FormService.getLidZoekenSubFunctionsForMember();
      if (memberDetails && memberDetails.memberName) {
        nameMemberInLidZoekenSubfunction = memberDetails.memberName;
        showLineBelowTitleBlock = true;

        memberState = <span className={"member-state " + (memberDetails.isMember ? "member-state--is-member" : "")}></span>;
      }
    } else if (this.state.IsMember !== undefined && this.state.FullName !== "") {
      nameMemberInLidZoekenSubfunction = this.state.FullName;
      showLineBelowTitleBlock = true;

      memberState = <span className={"member-state " + (this.state.IsMember ? "member-state--is-member" : "")}></span>;
    }

    let showTitleBlock = true;
    let showColumns = true;
    let stickySidebar = false;
    if (this.props.layoutType === "modern") {
      showTitleBlock = !!props.showTitleBlock;
      showColumns = true;
      stickySidebar = true;
      if (this.props.stickySidebar !== undefined) {
        stickySidebar = !!this.props.stickySidebar;
      }      
      cssColumnsContentContainer = "col-12 col-md-12 col-lg-10";
    }

    if (this.props.customEditPageClass && this.props.customEditPageClass !== "") {
      pageRowCssClass += " " + this.props.customEditPageClass; 
    }

    this.handleAnimations();
    
    let mainBlockEditPageCssClass =  "mainBlock col-12 mijn-fnv__edit-page " + pageWidthCssClass + " " +
    (showTitleBlock ? "" : "form--no-page-title");
    
    if (this.props.layoutType === "modern") {
      // this removes the unnecessary paddings on mobile view
      cssColumnsContentContainer += " p-0 px-md-2";
      // this removes the unnecessary paddings on mobile view
      mainBlockEditPageCssClass += " p-0 px-md-2";
      // this removes the negative margins to prevent a horizontal scrollbar on mobile view
      mainBlockRowCssClass += "  mr-0 ml-0 mr-md-n2 ml-md-n2";
    }    
    return (
      <React.Fragment>        
        {(!standaloneFormInSite && showTitleBlock) && (
          <div className="row mijn-fnv__edit-page-header">
            <div className="col-12 col-md-1" />
            <div className="col-12 col-md-12 col-lg-10 mijn-fnv__edit-page-header-content">
                <HeaderWrapper modern={this.props.layoutType === "modern"} pageWidthCssClass={pageWidthCssClass}>
                {PageHelpers.isNotCreateAccountPage(props.pathName) &&
                  (props.withBackLink === undefined || props.withBackLink) && (
                    <BackLink backToPageLinkText={backToPageLinkText}
                       backToPageLinkUrl={backToPageLinkUrl}
                       isExternalUrl={!!BackLinkIsExternal} 
                    ></BackLink>
                  )}
                <h1
                  className={
                    showLineBelowTitleBlock && "content__title-with-subtitle"
                  }
                >
                  {props.kenticoPage.MijnFnvEditPagina.Titel}
                </h1>
                {nameMemberInLidZoekenSubfunction &&
                  nameMemberInLidZoekenSubfunction !== "" && (
                    <h2 className="content__subtitle content__subtitle-member-name">
                      {memberState}{nameMemberInLidZoekenSubfunction}
                    </h2>
                  )}
                {props.subTitle && props.subTitle !== "" && (
                  <h2 className="content__subtitle">{props.subTitle}</h2>
                )}
                {props.introText && props.introText !== "" && (
                  <p className="content__intro">{ReactHtmlParser(props.introText)}</p>
                )}
                {showLineBelowTitleBlock && <div className="content__hr"></div>}
                {props.content &&
                  props.content !== "" &&
                  !props.contentAfterForm && (
                    <div className="content__before-form">
                      {ReactHtmlParser(props.content)}
                    </div>
                  )}
              </HeaderWrapper>    
            </div>
            <div className="col-12 col-md-1" />
          </div>
        )}
        <div className={pageRowCssClass}>
          {!standaloneFormInSite && showColumns && <div className="col-12 col-md-1" />}
          {props.kenticoPage.MijnFnvEditPagina.ShowSideBar ? (
            <div className="mijn-fnv__sidemenu col-12 col-md-2">
              {MijnFNVMenu(PageHelpers.getSideMenu(props.kenticoPage), "")}
            </div>
          ) : null}
          <div className={cssColumnsContentContainer}>
            <div className={mainBlockRowCssClass}>
              <div
                className={mainBlockEditPageCssClass}
              >
                {(!standaloneFormInSite && !showTitleBlock) && PageHelpers.isNotCreateAccountPage(props.pathName) &&
                    (props.withBackLink === undefined || props.withBackLink) && (
                      <div className="form form__react pb-0 backbutton-container-in-page">
                        <BackLink backToPageLinkText={backToPageLinkText}
                          backToPageLinkUrl={backToPageLinkUrl}
                          isExternalUrl={!!BackLinkIsExternal}
                          additionalClassName="pl-40 pr-40 pt-40 pb-0 mb-0"
                      ></BackLink>
                    </div>
                )}
                {PageHelpers.getWidgets(props.kenticoPage).map(
                  (widgetDefinition, index) => {
                    const definition = {
                      ...widgetDefinition,
                      editMode: true,
                      sidebarRef: this.sidebarRef,
                      stepsContainerRef: props.kenticoPage.stepsContainerRef,
                      layoutType: this.props.layoutType,
                    };
                    return PageRenderHelpers.renderWidget(
                      definition,
                      "",
                      index,
                      "edit",
                      additionalId
                    );
                  }
                )}

                {props.content &&
                  props.content !== "" &&
                  !!props.contentAfterForm && (
                    <div className="content__after-form">
                      {ReactHtmlParser(props.content)}
                    </div>
                  )}
              </div>
              <div className="col-12 col-md-4 p-0" ref={this.sidebarRef}>
              {this.sidebarRef.current?.innerHTML == null &&
                <>
                {!stickySidebar && sidebar != "" && <div>{sidebar}</div>}
                {!!stickySidebar && <StickyBox offsetTop={0} offsetBottom={20}>
                    <div className="sidebar-holder">
                      <SidebarContent></SidebarContent>
                      {sidebar != "" && (
                        <div>{sidebar}</div>
                      )}                    
                    </div>
                  </StickyBox>
                }
                </>
              }
              </div>
            </div>
          </div>
          {!standaloneFormInSite && showColumns && <div className="col-12 col-md-1" />}
        </div>
      </React.Fragment>
    );
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}
